import React from 'react';
import { Route } from 'react-router-dom';

import { PUBLIC_AUTHENTICATION_APP_PATHS } from '../constants/authentication-paths.constants';
import LoginView from '../views/public/Login.view';
import SignupView from '../views/public/Signup.view';
import ForgotPasswordView from '../views/public/ForgotPassword.view';
import ResetPasswordView from '../views/public/ResetPassword.view';

const RESET_PASSWORD_ROUTE_PATH = PUBLIC_AUTHENTICATION_APP_PATHS.RESET_PASSWORD.replace('/:token', '/:token?');

export default function PublicAuthenticationRoutes() {
  return (
    <React.Fragment>
      <Route exact path={PUBLIC_AUTHENTICATION_APP_PATHS.LOGIN} component={LoginView} />
      <Route exact path={PUBLIC_AUTHENTICATION_APP_PATHS.SIGNUP} component={SignupView} />
      <Route exact path={PUBLIC_AUTHENTICATION_APP_PATHS.FORGOT_PASSWORD} component={ForgotPasswordView} />
      <Route exact path={RESET_PASSWORD_ROUTE_PATH} component={ResetPasswordView} />
    </React.Fragment>
  );
}
